module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Getting the Most Out of "), _c('i', [_vm._v("The Messiah")])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    },
    attrs: {
      "border": ""
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "60%",
      "padding": "7px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%",
      "padding": "7px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('b', [_vm._v("1 His Name Is Wonderful"), _c('br'), _c('i', [_vm._v("Messiah’s Character")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("Isaiah 9:6-7")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2 The Virgin Will Be with Child"), _c('br'), _c('i', [_vm._v("Messiah’s Birth")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 7:1-16; Matthew 1:18-25")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 The Lame Will Walk"), _c('br'), _c('i', [_vm._v("Messiah’s Miracles")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 35:3-6; Matthew 11:1-6")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 Why Have You Forsaken Me?"), _c('br'), _c('i', [_vm._v("Messiah’s Death")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 22:1-21")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 Pierced for Our Transgressions"), _c('br'), _c('i', [_vm._v("Messiah’s Sacrifice")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 53:1-10")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 The Path of Life"), _c('br'), _c('i', [_vm._v("Messiah’s Resurrection")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 16:7-11; Acts 2:22-32")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7 Lift Up Your Heads"), _c('br'), _c('i', [_vm._v("Messiah’s Exaltation")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 24")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8 The Clouds of Heaven"), _c('br'), _c('i', [_vm._v("Messiah’s Return")])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "bottom"
    }
  }, [_c('p', {
    staticClass: "SOM_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel 7:9-14; Revelation 19:1-16")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leader’s Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LifeGuide® in Depth Bible Studies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0